/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import registerStep2 from '../../assets/images/register/register-step-2-4.svg';
import member from "../../assets/images/register/member.svg";

import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { useDispatch, useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import calendar from "../../assets/images/icon/calendar.svg";
import InputLabel from '@mui/material/InputLabel';
import { useLiff } from 'react-liff';
import { setRegisterMain } from "../../features/register/RegisterMainSlice";


export default function RegisterMember1() {

  // lineId
  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  const yesterday = dayjs().subtract(1, "day");
  const store = useSelector((state) => state.registerMain)
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const { register, setError, formState: { errors }, handleSubmit, clearErrors, control, watch } = useForm({
    defaultValues: {
      firstName: store['firstName'],
      lastName: store['lastName'],
      mobileNumber: store['mobileNumber'],
      email: store['email'],
      birthDate: store['birthDate']
    }
  });

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setRegisterMain(tmpObj));
  }

  function isValidEmail(email) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);
  }

  const handleChangeEmail = event => {
    if (event.target.value && !isValidEmail(event.target.value)) {
      setError('email', {
        type: "email",
        message: "อีเมลไม่ถูกต้อง"
      });
    } else {
      fnSetData('email', event.target.value)
      clearErrors('email');
    }
  };

  React.useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name && type) {
        fnSetData(name, value[name]);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (data) => {
    fnSetData('birthDate', data.birthDate)
    navigate("/register-member-2", { state: data });
  };


  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
        <TopLogo />
        <TopBanner type="register" />
        <Container maxWidth="xl" className="mt-[-20px]">
          <div className="bg-white px-3">
            <img src={registerStep2} alt="logo" style={{ width: "100%" }} />
            <div style={{ fontSize: 30, textAlign: "center" }}>
              ลงทะเบียนสำหรับ
              <span style={{ fontWeight: "bold" }}> ผู้ใช้งานทั่วไป</span>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={member}
                alt="logo"
                style={{ width: "20%", display: "initial" }}
              />
            </div>
            <div style={{ padding: "0 10px" }}>
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ข้อมูลผู้ใช้</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> User Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>


              <div className="grid grid-cols-2 gap-2">
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtFirstName">ชื่อ </InputLabel>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtLastName">นามสกุล </InputLabel>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <TextField
                  id="txtFirstName"
                  required
                  fullWidth
                  error={!!errors?.firstName}
                  helperText={errors?.firstName?.message}
                  {...register("firstName", { required: "กรุณากรอกชื่อ" })}
                />

                <TextField
                  id="txtLastName"
                  required
                  fullWidth
                  error={!!errors?.lastName}
                  helperText={errors?.lastName?.message}
                  {...register("lastName", { required: "กรุณากรอกนามสกุล" })}
                />
              </div>

              <div className={errors?.firstName || errors?.lastName ? '' : ' mt-2'}>
                <InputLabel className="text-header1 text-required text-left" htmlFor="txtMobileNumber">เบอร์โทรศัพท์ </InputLabel>
                <TextField
                  id="txtMobileNumber"
                  fullWidth
                  required
                  type="number"
                  error={!!errors?.mobileNumber}
                  helperText={errors?.mobileNumber?.message}
                  placeholder="เบอร์โทรศัพท์ของคุณ"
                  {...register("mobileNumber", { required: "กรุณากรอกเบอร์โทรศัพท์" })}
                // onChange={handleChangeEmail}
                />
              </div>

              <div className={errors?.mobileNumber ? '' : ' mt-2'}>
                <InputLabel className="text-header1 text-left" htmlFor="txtEmail">อีเมล </InputLabel>
                <TextField
                  id="txtEmail"
                  fullWidth
                  error={!!errors?.email}
                  helperText={errors?.email?.message}
                  placeholder="อีเมลของคุณ"
                  {...register("email", {
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "อีเมลไม่ถูกต้อง"
                    }
                  })
                  }
                  onChange={handleChangeEmail}
                />
              </div>

              <div className={errors?.email ? 'relative' : 'relative mt-2'}>
                <InputLabel required={true} className="text-header1 text-required text-left" htmlFor="txtEmail">วัน/เดือน/ปี ที่เกิด </InputLabel>
                <Controller
                  name="birthDate"
                  control={control}
                  rules={{
                    required: "กรุณาเลือกวัน/เดือน/ปีที่เกิด",
                  }}
                  render={({ field }) => (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        {...field}
                        className="w-full"
                        inputFormat="DD/MM/YYYY"
                        value={field.value ? dayjs(field.value) : null}
                        maxDate={yesterday}
                        name="birthDate"
                        onChange={(date) => field.onChange(date)}
                        renderInput={(params) => (
                          <TextField
                            name="birthDate"
                            {...params}
                            error={!!errors?.birthDate}
                            helperText={errors?.birthDate?.message}
                            placeholder="วัน / เดือน / ปี"
                          />
                        )}
                      />
                      <img
                        className={
                          `absolute right-[10px] bottom-[15px] w-[18px] pointer-events-none ` +
                          (!!errors?.birthDate
                            ? "bottom-[42px]"
                            : null)
                        }
                        src={calendar}
                        alt=""
                      />
                    </LocalizationProvider>
                  )}
                />
              </div>
              <br></br>
            </div>
          </div>
        </Container>
        <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
          <Stack
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => navigate('/register')}>
              ย้อนกลับ
            </SecondaryButton>
            <PrimaryButton variant="contained" className="w-[40%]" type="submit">
              ต่อไป
            </PrimaryButton>
          </Stack>
        </div>
      </form>
    </>
  );
}
